// Chakra imports
import {
  Flex,
  FormLabel,
  SimpleGrid,
  Text,
  Select,
  useColorModeValue,
  Button,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
} from "@chakra-ui/react";
import Card from "components/card/Card";
import InputField from "components/fields/InputField";
import {
  alteraClienteAtendimento2,
  buscaCep,
  cadastraCliente,
  getOperadoras,
  checkUserDoc,
} from "config/apis/requests";
import {
  maskCep,
  ufSelect,
  maskSemPontos,
  maskCelular,
  IsEmpty,
  isEmail,
  IsNotEmpty,
  maskOnlyNumbers,
  maskDataInfo,
  maskDatainfor,
  convertData,
  isDateStringValid,
  maskDataHistoricoSemHora,
  maskCpfCnpj,
  formatarNomeCompleto,
} from "config/functions";
import { useEffect, useState } from "react";
import { MdCreate } from "react-icons/md";
import { ClientePessoaFisica } from "./Cliente";
import { isEmpty } from "@chakra-ui/utils";
import PopOverAlert from "components/popAlert/popAlert";
import Camera from "components/camera/Camera";

export default function Information(props: {
  cpfHandleProtocolo: any;
  dataUser: any;
  cpfBusca: any;
  matriculaBusca: any;
  cadSusBusca: any;
  docAlternativo: any;
  loginNovo: any;
  handleFotoAlterada: any;
  solicitarCartao: any;
  handleCepNovoUser: any;
  handleAtualizaEndereco: any;
  fotoAlteradaUserData: any;
  ticketGerado: any;
}) {
  const {
    dataUser,
    cpfBusca,
    matriculaBusca,
    docAlternativo,
    handleFotoAlterada,
    cadSusBusca,
    solicitarCartao,
    cpfHandleProtocolo,
    handleCepNovoUser,
    handleAtualizaEndereco,
    fotoAlteradaUserData,
  } = props;
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const [dataRec, setDataRec] = useState("");
  const [dtNascimento, setDtNascimento] = useState("");
  const [nome, setNome] = useState("");
  const [nomeSocial, setNomeSocial] = useState("");
  const [id, setId] = useState("");
  const [email, setEmail] = useState("");
  const [operadora, setOperadora] = useState([]);
  const [telefone, setTelefone] = useState("");
  const [sexo, setSexo] = useState("");
  const [cpf, setCpf] = useState("");
  const matricula: string = "";
  const [documentoAlternativo, setDocumentoAlternativo] = useState("");
  const cadSus: string = "";
  const [disableCadastro, setDisableCadastro] = useState(false);
  const [cep, setCep] = useState("");
  const [cidade, setCidade] = useState("");
  const [bairro, setBairro] = useState("");
  const [complemento, setComplemento] = useState("");
  const [uf, setUF] = useState("");
  const [numero, setNumero] = useState("");
  const [dataCadastro, setDataCadastro] = useState("");
  const [logradouro, setLogradouro] = useState("");
  const [nrSeqEndereco, setNrSeqEndereco] = useState(0);
  const cliente = new ClientePessoaFisica();
  const [isOpen, setIsOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [idOperadora, setIdOperadora] = useState<number | null>(null); //tirar depois o dois quando tiver usuario com idOperadora
  const recoverLoggedUser: any = [JSON.parse(localStorage.getItem("user"))];
  const textColor = useColorModeValue("secondaryGray.900", "white");

  const handleAccordionButtonClick = (index: any) => {
    setActiveIndex(index === activeIndex ? undefined : index);
  };

  const [loading, setLoading] = useState(false);
  const [statusPopOver, setStatusPopOver] = useState("warning");
  const [titlePopOver, setTitlePopOver] = useState("Ops...");
  const [subtitlePopOver, setSubtitlePopOver] = useState("");
  const handleOpenAlert = (status: boolean) => {
    setIsOpen(status);
  };
  const [fotoAlterada, setFotoAlterada] = useState("");
  const [restricao, setRestricao] = useState(false);
  const [loadingCep, setLoadingCep] = useState(false);

  const handleFoto = (foto: any) => {
    if (foto !== "") {
      setFotoAlterada(foto.replace("data:image/jpeg;base64,", ""));
      handleFotoAlterada(foto.replace("data:image/jpeg;base64,", ""));
    }
  };
  interface PerfisUsuario {
    perfis: string[];
  }

  const usuarios: PerfisUsuario[] = [
    {
      perfis: recoverLoggedUser[0]?.perfis,
    },
  ];

  const perfisDesejados = [
    "ADMINISTRADOR",
    "SUPERVISOR_ESTUDANTE",
    "SUPERVISOR_PCD",
    "SUPERVISOR_SENIOR",
    "SUPERVISOR_LOJA",
    "ATENDENTE_LOJA",
    "CADASTRO_ESTUDANTE",
    "CADASTRO_PDC",
    "CADASTRO_SENIOR",
  ];

  const perfisDesejadosCadastroAlteracao = [
    "ADMINISTRADOR",
    "SUPERVISOR_ESTUDANTE",
    "SUPERVISOR_PCD",
    "SUPERVISOR_SENIOR",
    "SUPERVISOR_LOJA",
    "CADASTRO_ESTUDANTE",
    "CADASTRO_PDC",
    "CADASTRO_SENIOR",
  ];

  const perfisDesejadosDataNascimento = ["ADMINISTRADOR", "SUPERVISOR_LOJA"];
  const showPopOver = (status: string, title: string, subtitle: string) => {
    handleOpenAlert(true);
    setStatusPopOver(status);
    setTitlePopOver(title);
    setSubtitlePopOver(subtitle);
  };

  const validateFormData = (valDate: any) => {
    const erros = [];
    if (
      (!isEmpty(valDate) &&
        !isDateStringValid(
          valDate.substring(0, 2) +
            "/" +
            valDate.substring(2, 4) +
            "/" +
            valDate.substring(4, 10),
        )) ||
      valDate === ""
    ) {
      erros.push("Data de Nascimento deve ser válida!");
      setDataRec("");
    } else {
      setDtNascimento(
        convertData(
          valDate.substring(0, 2) +
            "/" +
            valDate.substring(2, 4) +
            "/" +
            valDate.substring(4, 10),
        ),
      );
    }

    if (IsEmpty(erros)) {
      return true;
    } else {
      erros.map((e) => {
        showPopOver("error", "Ops...", e);
        return false;
      });
    }
  };

  const validateForm = () => {
    const erros = [];

    if (cep) {
      if (IsEmpty(logradouro) && !isEmpty(cep)) {
        erros.push("O cep está incompleto ou inválido!");
        setCep("");
      } else if (IsEmpty(numero)) {
        erros.push("O número do endereço deve ser preenchido!");
      }
    }
    if (["Partiu"].some((env) => window.config.tenant.includes(env))) {
      if (idOperadora === null) {
        erros.push("Escolha a operadora!");
      }
    }
    if (IsEmpty(nome)) {
      erros.push("Nome Completo deve ser preenchido!");
    }

    if (!IsEmpty(email)) {
      // erros.push("Email deve ser preenchido!");

      if (!isEmail(email)) {
        erros.push("Preencha com um email válido!");
      }
    }

    if (IsEmpty(dataRec)) {
      erros.push("Preencha com uma data de nascimento válida!");
    }
    //pedido do barbosa, tirar validação 05/12/23
    // if (IsEmpty(dataUser?.base64Imagem)) {
    //   setLoading(false);
    //   if (IsEmpty(fotoAlterada) && IsEmpty(fotoAlteradaUserData)) {
    //     erros.push("Cliente sem foto!");
    //   }
    // }

    if (IsEmpty(telefone)) {
      erros.push("Celular deve ser preenchido!");
    }

    if (IsEmpty(erros)) {
      return true;
    } else {
      setLoading(false);
      erros.map((e) => {
        showPopOver("error", "Ops...", e);
        return false;
      });
    }
  };

  const handleFocusChange = async (cepChange: any) => {
    setLoadingCep(true);
    const { estado, cidade, bairro, logradouro, restricao } =
      await buscaCep(cepChange);
    if (estado === 500 || estado === 400 || estado === 404) {
      showPopOver("error", "Ops...", "Erro ao buscar CEP!");
      setLoadingCep(false);
      return;
    } else if (
      bairro === "" ||
      cidade === "" ||
      logradouro === "" ||
      estado === ""
    ) {
      showPopOver("error", "Ops...", "Digite um CEP válido!");
      setLoadingCep(false);
      return;
    }
    setLoadingCep(false);

    if (restricao === 1) {
      setRestricao(true);
    } else {
      setRestricao(false);
    }

    if (!cepChange.includes(".")) {
      setUF(estado);
      setBairro(bairro);
      setCidade(cidade);
      setLogradouro(logradouro);
      setUF(estado);
    } else {
      setCep(cepChange);
      setUF("");
      setBairro("");
      setCidade("");
      setLogradouro("");
    }
  };

  useEffect(() => {
    const fetchOperadoras = async () => {
      const operadorasResponse = await getOperadoras();
      if (
        !isEmpty(operadorasResponse) &&
        operadorasResponse !== 500 &&
        operadorasResponse !== 400 &&
        operadorasResponse !== 404
      ) {
        localStorage.setItem("operadoras", JSON.stringify(operadorasResponse));
        setOperadora(operadorasResponse);
      }
    };
      fetchOperadoras();

  }, []);

  useEffect(() => {
    if (!isEmpty(dataUser)) {
      setActiveIndex(1);
      setNome(dataUser.nome);
      setNomeSocial(dataUser.nomeSocial === null ? "" : dataUser.nomeSocial);
      if (IsNotEmpty(dataUser?.telefone)) {
        setTelefone(maskCelular(dataUser?.telefone));
      }

      setDataRec(
        dataUser.dataNascimento
          ? maskDataInfo(dataUser.dataNascimento + "T00:00:00")
          : "",
      );
      setSexo(dataUser.sexo);
      setDataCadastro(dataUser.dataCadastro);
      setEmail(dataUser.email);
      setIdOperadora(dataUser?.idOperadora); //depois voltar com o campo certo vindo do DataUser
      if (dataUser.tipoDocumento.codigo === 6) {
        setDocumentoAlternativo(dataUser.numeroDocumento);
        setCpf("");
      } else if (dataUser.tipoDocumento.codigo === 4) {
        setDocumentoAlternativo(dataUser.numeroDocumento);
        setCpf("");
      } else if (dataUser.tipoDocumento.codigo === 1) {
        setCpf(maskCpfCnpj(dataUser.numeroDocumento));
        setDocumentoAlternativo(dataUser.numeroDocumentoAlternativo);
      }
      setId(dataUser.codigo);

      setDisableCadastro(false);
      if (
        !isEmpty(dataUser.enderecos[0]?.cep) &&
        dataUser.enderecos[0]?.cep !== undefined
      ) {
        setNrSeqEndereco(dataUser?.enderecos[0].nrSeqEndereco);
        setCep(maskCep(dataUser?.enderecos[0].cep));
        handleFocusChange(dataUser?.enderecos[0].cep);
        setUF(dataUser?.enderecos[0].uf);
        setBairro(dataUser?.enderecos[0].bairro);
        setNumero(dataUser?.enderecos[0].numero);
        setComplemento(dataUser?.enderecos[0].complemento);
        setCidade(dataUser?.enderecos[0].cidade);
        setLogradouro(dataUser?.enderecos[0].logradouro);
      } else {
        setNrSeqEndereco(null);
        setCep("");
        setUF("");
        setBairro("");
        setSexo("M");
        setNumero("");
        setCidade("");
        setLogradouro("");
        // setCpf(cpfBusca);
        setComplemento("");
      }
    } else {
      // if (
      //   base64Imagem === undefined ||
      //   base64Imagem === "" ||
      //   handleFotoAlterada === false
      // ) {
      setCpf(cpfBusca || "");
      setDocumentoAlternativo(matriculaBusca || cadSusBusca);
      setDataRec("");
      setNome("");
      setTelefone("");
      setDtNascimento("");
      setNrSeqEndereco(null);
      setCep("");
      setUF("");
      setEmail("");
      setBairro("");
      setSexo("M");
      setNumero("");
      setCidade("");
      setLogradouro("");
      setComplemento("");
      //}
    }
  }, [dataUser]);
  // }, [dataUser, handleFotoAlterada, fotoAlteradaUserData]);

  const cadastrarUsuario = async () => {
    if (validateForm()) {
      setLoading(true);
      setDisableCadastro(false);
      cliente.base64Imagem = fotoAlterada.replace(
        "data:image/jpeg;base64,",
        "",
      );
      cliente.tipoImagem = "IMAGEM_ROSTO";
      cliente.nome = nome.trim();
      cliente.nomeSocial = nomeSocial;
      cliente.dataNascimento = dataRec && convertData(dataRec);
      cliente.email = email;
      if (idOperadora) {
        cliente.idOperadora = idOperadora;
      }
      if (cpfBusca === "" && cadSusBusca === "" && matriculaBusca !== "") {
        cliente.tipoDocumento = "MATRICULA";
        cliente.numeroDocumento = maskOnlyNumbers(matriculaBusca);
      } else if (
        cpfBusca !== "" &&
        matriculaBusca !== "" &&
        cadSusBusca !== ""
      ) {
        cliente.tipoDocumento = "CPF";
        cliente.numeroDocumento = maskOnlyNumbers(cpfBusca);
        cliente.numeroDocumentoAlternativo =
          documentoAlternativo || docAlternativo;
      } else if (
        cpfBusca === "" &&
        matriculaBusca === "" &&
        cadSusBusca !== ""
      ) {
        cliente.tipoDocumento = "CNS";
        cliente.numeroDocumento = maskOnlyNumbers(cadSusBusca);
      } else {
        cliente.tipoDocumento = "CPF";
        cliente.numeroDocumento = maskOnlyNumbers(cpfBusca);
        cliente.numeroDocumentoAlternativo = documentoAlternativo;
      }
      cliente.celular = maskOnlyNumbers(telefone);
      cliente.telefone = maskOnlyNumbers(telefone);
      cliente.sexo = "";
      // cliente.nomeMae = "";
      // cliente.nomePai = "";
      cliente.senha = "";
      cliente.confirmacaoSenha = "";
      if (idOperadora) {
        cliente.idOperadora = idOperadora;
      } else {
        cliente.idOperadora = null;
      }
      if (IsNotEmpty(cep)) {
        cliente.cidade = cidade;
        cliente.cep = maskOnlyNumbers(cep);
        cliente.bairro = bairro;
        cliente.logradouro = logradouro;
        cliente.numero = numero;
        cliente.idTipoEndereco = 2;
        cliente.complemento = complemento;
        cliente.uf = uf;
      } else {
        delete cliente.cidade;
        delete cliente.cep;
        delete cliente.nrSeqEndereco;
        delete cliente.bairro;
        delete cliente.logradouro;
        delete cliente.numero;
        delete cliente.idTipoEndereco;
        delete cliente.complemento;
        delete cliente.uf;
        delete cliente.idTipoLogradouro;
        delete cliente.latitude;
        delete cliente.longitude;
        delete cliente.id;
      }
      cliente.idTiposPerfisCliente = [2];

      await checkUserDoc(
        cliente.numeroDocumento,
        cliente.nome,
        cliente.dataNascimento,
      ).then(async function (result) {
        if (result !== 500 && result !== 400 && result !== 404) {
          if (typeof result !== "number" && result.data) {
            const nationalRegistrationStatusApproved =
              result?.data?.nationalRegistrationStatusApproved;
            const nameApproved = result?.data?.nameApproved;
            const birthDateApproved = result?.data?.birthDateApproved;
            if (
              (nationalRegistrationStatusApproved === true &&
                nameApproved === true &&
                birthDateApproved === true) ||
              window.config.tenant === "Dev" ||
              window.config.tenant === "Homolog" ||
              window.config.tenant === "Partiu"
            ) {
              cadastraCliente(cliente).then(function (result) {
                if (result !== 400 && result !== 500 && result) {
                  solicitarCartao(
                    true,
                    cpf || cpfBusca ? cpf || cpfBusca : docAlternativo,
                  );
                  if (cep) {
                    handleCepNovoUser(maskOnlyNumbers(cep));
                  }
                  setDisableCadastro(true);
                  cpfHandleProtocolo(
                    maskOnlyNumbers(
                      cpf || cpfBusca ? cpf || cpfBusca : docAlternativo,
                    ),
                  );
                  showPopOver("success", "Cadastro", "Salvo com sucesso!");
                  setLoading(false);
                } else {
                  showPopOver(
                    "error",
                    "Ops...",
                    result?.response?.data?.errorMessages
                      ? result?.response?.data?.errorMessages
                      : "Erro ao cadastrar usuário!",
                  );
                  setLoading(false);
                }
              });
            } else {
              if (nationalRegistrationStatusApproved == false) {
                showPopOver("error", "Ops...", "Cpf inválido! Erro Dock!");
              }

              if (nameApproved == false) {
                showPopOver(
                  "error",
                  "Ops...",
                  "Nome informado não condiz com o nome registrado no documento!",
                );
              }

              if (birthDateApproved == false) {
                showPopOver(
                  "error",
                  "Ops...",
                  "Data nascimento informado não condiz com a data registrado no documento!",
                );
              }
              setLoading(false);
            }
          }
        } else {
          showPopOver("error", "Ops...", "Erro ao validar cadastro na Dock!");
          setLoading(false);
        }
      });
    }
  };

  const alterar = () => {
    setLoading(true);
    if (validateForm()) {
      cliente.base64Imagem = fotoAlteradaUserData
        ? fotoAlteradaUserData
        : handleFotoAlterada
          ? handleFotoAlterada
          : dataUser.base64Imagem;
      cliente.tipoImagem = "IMAGEM_ROSTO";
      cliente.nome = nome.trim();
      cliente.nomeSocial = nomeSocial;
      cliente.dataNascimento = convertData(dataRec);
      cliente.email = email;
      cliente.id = id;

      if (idOperadora) {
        cliente.idOperadora = idOperadora;
      }
      if (!IsEmpty(dataUser)) {
        if (dataUser.tipoDocumento.codigo === 4) {
          if (cpf || cpfBusca) {
            cliente.tipoDocumento = "CPF";
            cliente.numeroDocumento = maskOnlyNumbers(cpf || cpfBusca);
            cliente.numeroDocumentoAlternativo =
              documentoAlternativo || docAlternativo;
          } else {
            cliente.tipoDocumento = "MATRICULA";
            cliente.numeroDocumento = maskOnlyNumbers(
              documentoAlternativo || matricula || matriculaBusca,
            );
          }
        } else if (dataUser.tipoDocumento.codigo === 6) {
          if (cpf || cpfBusca) {
            cliente.tipoDocumento = "CPF";
            cliente.numeroDocumento = maskOnlyNumbers(cpf || cpfBusca);
            cliente.numeroDocumentoAlternativo =
              documentoAlternativo || docAlternativo;
          } else {
            cliente.tipoDocumento = "CNS";
            cliente.numeroDocumento = maskOnlyNumbers(
              cadSus || cadSusBusca || documentoAlternativo || docAlternativo,
            );
          }
        } else if (cpf === "" && cadSus === "" && matricula !== "") {
          cliente.tipoDocumento = "MATRICULA";
          cliente.numeroDocumentoAlternativo = documentoAlternativo;
          cliente.numeroDocumento = maskOnlyNumbers(matricula);
        } else if (cpf !== "" && matricula !== "" && cadSus !== "") {
          cliente.tipoDocumento = "CPF";
          cliente.numeroDocumento = maskOnlyNumbers(cpfBusca);
          cliente.numeroDocumentoAlternativo = documentoAlternativo;
        } else if (cpf === "" && matricula === "" && cadSus !== "") {
          cliente.tipoDocumento = "CNS";
          cliente.numeroDocumento = maskOnlyNumbers(cadSus);
        } else {
          cliente.tipoDocumento = "CPF";
          cliente.numeroDocumento = maskOnlyNumbers(cpf);
          cliente.numeroDocumentoAlternativo =
            cadSus || cadSusBusca
              ? maskOnlyNumbers(cadSusBusca || cadSus)
              : maskOnlyNumbers(documentoAlternativo || matricula);
        }
      }
      cliente.celular = maskSemPontos(telefone);
      cliente.telefone = maskSemPontos(telefone);
      cliente.sexo = sexo;
      cliente.nomeMae = !isEmpty(dataUser) ? dataUser?.nomeMae : "";
      if (cep) {
        cliente.cidade = cidade;
        cliente.cep = maskOnlyNumbers(cep);
        cliente.nrSeqEndereco = nrSeqEndereco || 0;
        cliente.bairro = bairro;
        cliente.logradouro = logradouro;
        cliente.numero = numero;
        cliente.idTipoEndereco = 2;
        cliente.complemento = complemento;
        cliente.uf = uf;
      } else {
        delete cliente.cidade;
        delete cliente.cep;
        delete cliente.nrSeqEndereco;
        delete cliente.bairro;
        delete cliente.logradouro;
        delete cliente.numero;
        delete cliente.idTipoEndereco;
        delete cliente.complemento;
        delete cliente.uf;
        delete cliente.idTipoLogradouro;
        delete cliente.latitude;
        delete cliente.longitude;
      }
      if (dataUser) {
        delete cliente.senha;
        delete cliente.confirmacaoSenha;
      }
      cliente.idTiposPerfisCliente = [2];
      // delete cliente.nomeMae;
      // delete cliente.nomePai;
      if (!dataRec && !dtNascimento) {
        delete cliente.dataNascimento;
      }
      alteraClienteAtendimento2(cliente).then(function (result: any) {
        if (result.status === 200 || result.status < 400) {
          showPopOver("success", "Cadastro", "Cadastro alterado com sucesso!");
          handleAtualizaEndereco(true);
          setLoading(false);
        } else {
          const data = result?.response?.data;
          const erro =
            data?.errorMessages === undefined || IsEmpty(data?.errorMessages)
              ? "Erro ao alterar usuário. Entre em contato com o suporte."
              : data?.errorMessages;

          if (result?.status == 413) {
            showPopOver(
              "error",
              "Ops...",
              "A foto enviada excede o tamanho permitido. Por favor, entre em contato com o suporte.",
            );
          } else {
            showPopOver("error", "Ops...", erro);
          }

          setLoading(false);
        }
      });
    }
  };

  const podeEditar = usuarios[0]?.perfis?.some((perfil: string) =>
      perfisDesejadosCadastroAlteracao?.includes(perfil)
  );

  return (
    <>
      <PopOverAlert
        handleOpenAlert={handleOpenAlert}
        isOpen={isOpen}
        status={statusPopOver}
        title={titlePopOver}
        subtitle={subtitlePopOver}
      />

      <Card
        mb={{ base: "20px", md: "24px", lg: "32px" }}
        px={{ base: "16px", md: "24px", lg: "32px" }}
        py={{ base: "16px", md: "24px", lg: "32px" }}
        width="100%"
        maxW="100%"
        mx="auto"
        {...dataUser}
      >
        <Flex direction="column" mb="30px" ms="10px">
          <Text fontSize="xl" color={textColorPrimary} fontWeight="bold">
            Dados cadastrais
          </Text>
        </Flex>
        <SimpleGrid
          columns={{ base: 1, sm: 2, md: 3 }}
          spacing={{ base: "20px", xl: "20px" }}
        >
          <InputField
            isRequired={true}
            mb="20px"
            me={{ base: "0px", md: "30px" }}
            id="nome"
            label="Nome"
            //onPaste={handlePaste}
            value={formatarNomeCompleto(
              nome.replace(
                /[^a-zA-ZáàâãäéèêëíìîïóòôõöúùûüçñÁÀÂÃÄÉÈÊËÍÌÎÏÓÒÔÕÖÚÙÛÜÇÑ\s]/g,
                "",
              ),
            )}
            onChange={(e: {
              target: { value: React.SetStateAction<string> };
            }) => setNome(e.target.value)}
          />
          <InputField
            isRequired={true}
            mb="20px"
            me={{ base: "0px", md: "30px" }}
            id="nome"
            label="Nome social"
            value={nomeSocial}
            //onPaste={handlePaste}
            onChange={(e: {
              target: { value: React.SetStateAction<string> };
            }) => setNomeSocial(e.target.value)}
          />
          {/* todo */}
          <InputField
            isRequired={true}
            mb="0px"
            me={{ base: "0px", md: "30px" }}
            id="cpf"
            label="CPF"
            //onPaste={handlePaste}
            value={cpf || cpfBusca}
            disabled={ window.config.tenant === "macae" || !podeEditar }
            onChange={(e: {
              target: { value: React.SetStateAction<string> };
            }) => setCpf(maskCpfCnpj(e.target.value))}
          />

          <InputField
            //onPaste={handlePaste}
            mb="0px"
            me={{ base: "0px", md: "30px" }}
            id="documentoAlternativo"
            label={"Documento alternativo "}
            value={documentoAlternativo || docAlternativo}
            //disabled={documentoAlternativo || docAlternativo ? true : false}
            onChange={(e: {
              target: { value: React.SetStateAction<string> };
            }) => setDocumentoAlternativo(maskOnlyNumbers(e.target.value))}
          />
          <InputField
            //onPaste={handlePaste}
            isRequired={true}
            mb="20px"
            id="data"
            label={"Data nascimento"}
            isDisabled={
              isEmpty(dataUser) ||
              usuarios[0]?.perfis?.some((perfil: string) =>
                perfisDesejadosDataNascimento.includes(perfil),
              )
                ? false
                : true
            }
            maxLength="10"
            value={dataRec}
            onChange={(e: {
              target: { value: React.SetStateAction<string> };
            }) => {
              setDataRec(maskDatainfor(e.target.value));
              let varData = e.target.value;
              if (typeof varData === "string") {
                varData = varData.replace(/\//g, ""); // Remove todas as barras (/) da string
                if (varData.length === 8) {
                  validateFormData(varData);
                }
              }
            }}
          />

          <InputField
            //onPaste={handlePaste}
            isRequired={true}
            mb="20px"
            id="telefone"
            maxLength="15"
            label="Telefone"
            value={telefone}
            disabled={
              usuarios[0]?.perfis?.some((perfil: string) =>
                perfisDesejadosDataNascimento.includes(perfil),
              ) || isEmpty(dataUser)
                ? false
                : true
            }
            onChange={(e: {
              target: { value: React.SetStateAction<string> };
            }) => {
              setTelefone(maskCelular(e.target.value));
              if (e.target.value.length === 15) {
                setTelefone(maskCelular(e.target.value));
              }
            }}
          />
          <InputField
            //onPaste={handlePaste}
            isRequired={true}
            mb="20px"
            id="email"
            label="Email"
            value={email}
            disabled={
              usuarios[0]?.perfis?.some((perfil: string) =>
                perfisDesejadosDataNascimento.includes(perfil),
              ) || isEmpty(dataUser)
                ? false
                : true
            }
            onChange={(e: {
              target: { value: React.SetStateAction<string> };
            }) => setEmail(e.target.value)}
          />
          {["Partiu"].some((env) => window.config.tenant.includes(env)) && (
            <Flex direction="column" mb="20px">
              <Text
                fontSize="sm"
                fontWeight="700"
                color={textColor}
                mb="8px"
              >
                Operadora:
              </Text>
              <Select
                required={true}
                id="operadoras"
                name="operadoras"
                height="44px"
                fontSize="sm"
                fontWeight="500"
                borderRadius="16px"
                value={idOperadora ?? ""}
                //isDisabled={idOperadora && !isEmpty(dataUser) ? true : false}
                onChange={(e) => setIdOperadora(Number(e.target.value))}
              >
                <option value="">Selecione a operadora</option>
                {operadora
                  .filter((item: any) => item?.cliente?.nome)
                  .map((option: any) => (
                    <option key={option.id} value={option.id}>
                      {option.cliente.nome}
                    </option>
                  ))}
              </Select>
            </Flex>
          )}
          {dataCadastro ? (
            <InputField
              //onPaste={handlePaste}
              isRequired={true}
              mb="20px"
              id="dataCadastro"
              maxLength="15"
              label="Data cadastro"
              value={maskDataHistoricoSemHora(dataCadastro) || ""}
              disabled={true}
            />
          ) : null}
        </SimpleGrid>
        <Accordion allowToggle={true} allowMultiple index={activeIndex}>
          <AccordionItem>
            <AccordionButton onClick={() => handleAccordionButtonClick(0)}>
                <Box as="span" flex="1" textAlign="left">
                    <Text fontSize="xl" color={textColorPrimary} fontWeight="bold">
                        Endereço{restricao && (
                        <Text as="span" color="red" fontWeight="bold">
                            {" - "} Cep com restrição de entrega
                        </Text>
                    )}:
                    </Text>
                </Box>
              <AccordionIcon />
            </AccordionButton>

            <AccordionPanel pb={2}>

              <InputField
                //onPaste={handlePaste}
                isRequired={true}
                maxLength="10"
                mb="15px"
                me="0px"
                id="cep"
                w={{ base: "100%", md: "150px" }}
                label="Cep"
                value={cep}
                onChange={(e: { target: { value: any } }) => {
                  if (e.target.value.length === 8) {
                    handleFocusChange(e.target.value);
                  } else if (IsEmpty(e.target.value.length)) {
                    if (isEmpty(dataUser)) {
                      setNrSeqEndereco(0);
                    }
                    setBairro("");
                    setCidade("");
                    setComplemento("");

                    setUF("");
                    setLogradouro("");
                    setNumero("");
                    setRestricao(false);
                  }
                  setCep(maskCep(e.target.value));
                }}
              />

              {loadingCep ? (
                "Carregando..."
              ) : (
                <SimpleGrid
                  columns={{ base: 1, sm: 2, md: 3 }}
                  spacing={{ base: "20px", xl: "20px" }}
                >
                  <InputField
                    //onPaste={handlePaste}
                    disabled
                    isRequired={true}
                    mb="20px"
                    me={{ base: "0px", md: "30px" }}
                    id="logradouro"
                    label="Endereço"
                    value={logradouro}
                    onChange={(e: {
                      target: { value: React.SetStateAction<string> };
                    }) => setLogradouro(e.target.value)}
                  />
                  <InputField
                    isRequired={true}
                    mb="20px"
                    id="numero"
                    label="Número"
                    value={numero}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      const onlyNumbers = e.target.value.replace(/\D/g, "");
                      setNumero(onlyNumbers);
                    }}
                  />
                  <InputField
                    //onPaste={handlePaste}
                    isRequired={true}
                    mb="0px"
                    me={{ base: "0px", md: "30px" }}
                    id="complemeto"
                    label="Complemento"
                    value={complemento}
                    onChange={(e: {
                      target: { value: React.SetStateAction<string> };
                    }) => setComplemento(e.target.value)}
                  />
                  <InputField
                    //onPaste={handlePaste}
                    isRequired={true}
                    disabled
                    mb="0px"
                    me={{ base: "0px", md: "30px" }}
                    id="bairro"
                    label="Bairro"
                    value={bairro}
                    onChange={(e: {
                      target: { value: React.SetStateAction<string> };
                    }) => setBairro(e.target.value)}
                  />

                  <InputField
                    //onPaste={handlePaste}
                    mb="0px"
                    disabled
                    id="cidade"
                    label="Cidade"
                    value={cidade}
                    onChange={(e: {
                      target: { value: React.SetStateAction<string> };
                    }) => setCidade(e.target.value)}
                  />
                  <Flex direction="column" mb="30px">
                    <FormLabel
                      display="flex"
                      ms="10px"
                      fontSize="sm"
                      color={textColorPrimary}
                      fontWeight="bold"
                      _hover={{ cursor: "pointer" }}
                    >
                      <Text fontSize="sm" fontWeight="400" ms="2px">
                        <b>Estado</b>
                      </Text>
                    </FormLabel>
                    <Select
                      disabled
                      borderRadius="16px"
                      value={uf}
                      h="44px"
                      fontSize="sm"
                      fontWeight="500"
                      //disabled={!isNull(dataUser) ? true : false}
                      onChange={(e: {
                        target: { value: React.SetStateAction<string> };
                      }) => setUF(e.target.value)}
                    >
                      {ufSelect.map((option, index) => (
                        <option value={option.value} key={index}>
                          {option.label}
                        </option>
                      ))}
                    </Select>
                  </Flex>
                </SimpleGrid>
              )}
            </AccordionPanel>
          </AccordionItem>
        </Accordion>

        {!IsEmpty(dataUser) ||
        (nome !== "" &&
          dataRec !== "" &&
          telefone !== "" &&
          cpfBusca !== "") ? (
          <Flex justify="flex-start" mt="15px" h={"270px"} w={"823px"}>
            {usuarios[0]?.perfis?.some((perfil: string) =>
              perfisDesejados.includes(perfil),
            ) ? (
              <Camera
                dataUser={dataUser}
                handleFoto={handleFoto}
                cpfBusca={cpfBusca || matriculaBusca || cadSusBusca}
                nomeUser={nome}
                dtNascimento={dataRec}
                cep={cep}
                tipoDocumento={cpfBusca ? "CPF" : "MATRICULA"}
              ></Camera>
            ) : (
              <Flex
                direction={"row"}
                alignContent={"center"}
                align={"center"}
                mt={"-205px"}
              >
                <Text
                  ml={"20px"}
                  color={"red"}
                  align="center"
                  mt="20%"
                  fontSize="25"
                  fontWeight={"700"}
                  lineHeight="100%"
                >
                  Usuário sem permissão para inclusão de foto / alteração de
                  usuário
                </Text>
              </Flex>
            )}
          </Flex>
        ) : null}

        <SimpleGrid
          columns={{ sm: 1, md: 1 }}
          spacing={{ base: "20px", xl: "20px" }}
          alignSelf="flex-end"
        >
          {usuarios[0]?.perfis?.some((perfil: string) =>
            perfisDesejados.includes(perfil),
          ) ? (
            <Button
              mt={"23px"}
              onClick={!isEmpty(dataUser) ? alterar : cadastrarUsuario}
              leftIcon={<MdCreate />}
              variant="brand"
              width={"230px"}
              loadingText="Salvando dados"
              isLoading={loading}
              disabled={disableCadastro}
            >
              {isEmpty(dataUser) ? "Cadastrar Usuário" : "Atualizar dados"}
            </Button>
          ) : null}
        </SimpleGrid>
      </Card>
    </>
  );
}
